import { render } from "./InputTypeCheckbox.vue?vue&type=template&id=ce280c02"
import script from "./InputTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./InputTypeCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__